import { render } from "./customizeHomeworkSheet.vue?vue&type=template&id=7528b8b7&scoped=true"
import script from "./customizeHomeworkSheet.vue?vue&type=script&lang=js"
export * from "./customizeHomeworkSheet.vue?vue&type=script&lang=js"

import "./customizeHomeworkSheet.vue?vue&type=style&index=0&id=7528b8b7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7528b8b7"]])

export default __exports__